import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
// import { getToken } from '@/utils/auth'
const errorCodeArr = [
  'companyIsResiger',
  'emailIsResiger',
  'infoIsNull',
  'noPermission',
  'oldPasswordIsWrong',
  'emailSendError',
  'userCodeWrong',
  'userCodeInForce',
  'repetActice',
  'userCodeExpriy',
  'getLicenseError',
  'operationFailed',
  'machineCodeIsSame',
  'companyUnResiger',
  'accountOrPasswordWrong',
  'accountOutOfDate',
  'userNameIsSame'
]
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: '/dsim',
  // 超时
  timeout: 50000
})
// request拦截器
service.interceptors.request.use(config => {
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?'
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName]
      var part = encodeURIComponent(propName) + '='
      if (value !== null && typeof (value) !== 'undefined') {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']'
            var subPart = encodeURIComponent(params) + '='
            url += subPart + encodeURIComponent(value[key]) + '&'
          }
        } else {
          url += part + encodeURIComponent(value) + '&'
        }
      }
    }
    url = url.slice(0, -1)
    config.params = {}
    config.url = url
  }
  return config
}, error => {
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200
  // 获取错误信息--切换中英文
  let msg = res.data.msg || window.vm.$i18n.t('errorCode.default')
  if (res.data.code == 500 && errorCodeArr.includes(res.data.msg)) {
    msg = window.vm.$i18n.t(`errorCode.${res.data.msg}`)
  }
  if (code === 401) {
    MessageBox.confirm(window.vm.$i18n.t('errorCode.401tips'), window.vm.$i18n.t('errorCode.401title'), {
      confirmButtonText: window.vm.$i18n.t('errorCode.relogin'),
      cancelButtonText: window.vm.$i18n.t('errorCode.stay'),
      type: 'warning'
    }).then(() => {
      store.dispatch('user/logout').then(() => {
        location.href = '/login'
      })
    })
  } else if (code === 403 || code === 404) {
    Message({
      message: window.vm.$i18n.t(`errorCode.${code}`),
      type: 'error'
    })
    return Promise.reject(new Error(window.vm.$i18n.t(`errorCode.${code}`)))
  } else if (code === 500) {
    Message({
      message: msg,
      type: 'error'
    })
    return Promise.reject(new Error(msg))
  } else if (code === 501) {
    Message({
      message: window.vm.$i18n.t('dsimLogin.noResiger'),
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject('error')
  } else if (code === 502) {
    Message({
      message: window.vm.$i18n.t('dsimLogin.logPwdError'),
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject('error')
  } else if (code !== 200) {
    Message({
      message: msg,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject('error')
  } else {
    return res.data
  }
},
error => {
  let { message } = error
  if (message === 'Network Error') {
    message = window.vm.$i18n.t('errorCode.networkError')
  } else if (message.includes('timeout')) {
    message = window.vm.$i18n.t('errorCode.timeout')
  } else if (message.includes('Request failed with status code')) {
    message = window.vm.$i18n.t('errorCode.requestFailed1') + message.substr(message.length - 3) + window.vm.$i18n.t('errorCode.requestFailed2')
  }
  Message({
    message: message,
    type: 'error',
    duration: 5 * 1000
  })
  return Promise.reject(error)
}
)

export default service



// WEBPACK FOOTER //
// ./src/util/request.js